<div id="calendarSection" class="flex flex-col items-start gap-6 lg:gap-10 bg-background-dark px-5 md:px-18 lg:px-27 py-12 lg:py-27">
    <div>
        <h2 class="h3-text lg:h2-text text-white mb-2" i18n>Upcoming horse competitions</h2>
        <p class="body-m-text lg:body-l-text text-text-muted" i18n>Stay updated with the latest competitions around the world</p>
    </div>
    <table class="w-full table-fixed">
        <ng-container *ngIf="events$ | async; let events">
            <tr class="eventRow" *ngFor="let event of events">
                <td class="text-white pr-4 py-4 lg:py-8 body-s-text-bold lg:h4-text max-w-72">{{event.startDate | date: 'MMMM d, y'}} - {{event.endDate | date: 'MMMM d, y'}}</td>
                <td class="text-accent-blue pr-4 py-4 lg:py-8 body-s-text-bold lg:h4-text">{{event.locationName}}</td>
                <td class="text-white pr-4 py-4 lg:py-8 body-s-text lg:h4-text">{{event.eventRating}}</td>
                <td class="text-white pr-4 py-4 lg:py-8 body-s-text lg:h4-text">
                    <span [ngSwitch]="event.eventType">
                        <span *ngSwitchCase="EventType.Showjumping" i18n="@@show-jumping-competition-type">Show jumping</span>
                        <span *ngSwitchCase="EventType.Dressage" i18n="@@dressage-competition-type">Dressage</span>
                        <span *ngSwitchCase="EventType.Eventing" i18n="@@eventing-competition-type">Eventing</span>
                        <span *ngSwitchCase="EventType.Endurance" i18n="@@endurance-competition-type">Endurance</span>
                        <span *ngSwitchCase="EventType.Polo" i18n="@@polo-competition-type">Polo</span>
                        <span *ngSwitchCase="EventType.Racing" i18n="@@racing-competition-type">Racing</span>
                    </span>
                </td>
            </tr>    
        </ng-container>
    </table>
    <button routerLink="/competitions"
        class="base-button bg-white text-text-primary" 
        type="button" i18n>Load more</button>
</div>